import { ArgumentValidator } from '@/shared/helpers';
import { Component, Prop, Vue } from 'vue-property-decorator';

interface ILink {

    description: string;

    hyperTextReference: string;
}

@Component({})
export default class LinkManagerComponent extends Vue {

    @Prop() public inputName!: string;
    @Prop() public inputValue!: string;
    @Prop() public inputFieldCss!: string;
    @Prop() public translations!: { [key: string]: string; };
    @Prop() public disabled!: boolean;

    private links: ILink[] = [];

    constructor() {

        super();

        if (this.inputValue && this.inputValue.length > 0) {

            const parsed: ILink[] = JSON.parse(this.inputValue);

            if (parsed && parsed.length > 0) {

                this.links = parsed;
            }
        }

        // Hack, otherwise an new, empty row wouldn't be added (if empty list)
        setTimeout( () => {
            this.ensureOneEmptyRow();
        }, 10);
    }

    public get items(): ILink[] {

        return this.links;
    }

    public get currentValue(): string {

        let itemsWithData = this.links.filter(x => x.description !== '' || x.hyperTextReference !== '');

        if (!itemsWithData || itemsWithData.length <= 0) {

            itemsWithData = [];
        }

        return JSON.stringify(itemsWithData);
    }

    public get linkCount(): number {

        if (!this.links || this.links.length <= 0) {
            return 0;
        }

        return this.links.length;
    }

    public addLink($event: MouseEvent | null = null): void {

        if ($event) {
            $event.preventDefault();
        }

        if (this.disabled) {
            return;
        }

        this.links.push({
            description: '',
            hyperTextReference: ''
        });
    }

    public removeLink($index: number, $event: MouseEvent | null = null): void {

        if ($event) {
            $event.preventDefault();
        }

        ArgumentValidator.notLessThanZero($index, `$index`);

        if (this.disabled) {
            return;
        }

        this.links.splice($index, 1);

        this.ensureOneEmptyRow();
    }

    public moveDown($index: number, $event: MouseEvent | null = null): void {

        if ($event) {
            $event.preventDefault();
        }

        if (this.disabled) {
            return;
        }

        if ($index === (this.linkCount - 1)) {
            return;
        }

        this.moveItems(($index + 1), $index);
    }

    public moveUp($index: number, $event: MouseEvent | null = null): void {

        if ($event) {
            $event.preventDefault();
        }

        if (this.disabled) {
            return;
        }

        if ($index <= 0) {
            return;
        }

        this.moveItems(($index - 1), $index);
    }

    private ensureOneEmptyRow(): void {

        if (!this.links) {

            this.links = [];
        }

        if (this.links.length > 0) {

            return;
        }

        this.addLink();
    }

    private moveItems(to: number, from: number): void {

        ArgumentValidator.notLessThanZero(to, `to`);

        ArgumentValidator.notLessThanZero(from, `from`);

        this.links.splice(to, 0, this.links.splice(from, 1)[0]);
    }

}
